import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Button, Carousel, Pagination, Tree } from "ant-design-vue";
import "lib-flexible";
import VideoPlayer from "vue-video-player";
import * as filters from "@/utils/filter";
import "./global.css";
import "video.js/dist/video-js.css";
import "./video-custom-theme.css";
import GeminiScrollbar from "vue-gemini-scrollbar";

Vue.component(Button.name, Button);
Vue.component(Carousel.name, Carousel);
Vue.component(Pagination.name, Pagination);
Vue.component(Tree.name, Tree);

Vue.use(VideoPlayer);
Vue.use(GeminiScrollbar);
Vue.config.productionTip = false;

Object.keys(filters).forEach((key) => {
  Vue.filter(key, (filters as any)[key]);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
